import { Box, Container, Group, Stack, useMantineTheme } from "@mantine/core";

function SectionHeader({ children }: any) {
  const theme = useMantineTheme();
  return (
    <Container
      style={{
        background: "transparent",
        borderRadius: theme.radius.xs,
      }}
      py={"1rem"}
    >
      <Group align="flex-start" justify="flex-start" grow>
        <Stack gap={5}>
          <Box
            style={{
              position: "relative",
              display: "inline-block",
            }}
          >
            {children}
            <Box
              style={{
                position: "absolute",
                bottom: -10,
                left: "50%",
                transform: "translateX(-50%)",
                width: "80%",
                height: 4,
                background: `linear-gradient(90deg, 
                  transparent 0%, 
                  ${theme.colors.green[6]} 20%, 
                  ${theme.colors.teal[5]} 50%,
                  ${theme.colors.lime[6]} 80%,
                  transparent 100%
                )`,
                borderRadius: 2,
              }}
              py={1}
            />
          </Box>
        </Stack>
      </Group>
    </Container>
  );
}

export default SectionHeader;
